"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateItmCreate = exports.itmAuditSchema = exports.itmSchema = void 0;
var schema_validator_1 = require("@hobt/schema-validator");
var constants_1 = require("@hobt/constants");
var issue_to_management_type_1 = require("./issue-to-management-type");
var issue_to_management_delete_flag_1 = require("./issue-to-management-delete-flag");
var issue_to_management_status_1 = require("./issue-to-management-status");
exports.itmSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: ['cmhcLoanAccountNumber', 'statusCode', 'typeCodes', 'referenceNumber'],
    properties: {
        cmhcLoanAccountNumber: {
            type: 'integer',
            minimum: 1000000,
            maximum: 99999999,
            errorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_INVALID_ACCOUNT_NUMBER),
        },
        referenceNumber: {
            type: 'integer',
            minimum: 0,
            maximum: 2147483647,
            errorMessage: 'Should be numeric between 0 to 2147483647',
        },
        typeCodes: {
            type: 'array',
            minItems: 1,
            items: {
                type: 'number',
                enum: Object.values(issue_to_management_type_1.IssueToManagementType),
            },
            errorMessage: 'Should equate to a valid Types Enum value',
        },
        statusCode: {
            type: 'integer',
            enum: Object.values(issue_to_management_status_1.IssueToManagementStatus),
            errorMessage: 'Should equate to a valid Status Enum value',
        },
        deleteFlag: {
            type: 'integer',
            enum: Object.values(issue_to_management_delete_flag_1.IssueToManagementDeleteFlag),
            errorMessage: 'Should equate to a valid DeleteFlag Enum value',
        },
    },
};
exports.itmAuditSchema = {
    type: 'object',
    properties: {
        notApprovedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000',
        },
        approvedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordCreatedUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
    },
};
exports.validateItmCreate = function (data, addAuditFields) {
    if (addAuditFields === void 0) { addAuditFields = false; }
    var itmValidator = new schema_validator_1.SchemaValidator(exports.itmSchema, true, true, true, true);
    if (addAuditFields) {
        itmValidator.extendSchema(exports.itmAuditSchema);
    }
    return itmValidator.validate(data);
};
